import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const style = theme => ({
  dialog: {
    backgroundColor: theme.ModalBGColor,
    width: 300
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    color: theme.HeaderSelectedText,
    padding: "20px 25px 10px 25px"
  },
  dialogContent: {
    boxSizing: "border-box",
    padding: "0px 25px"
  },
  dialogAction: {
    padding: "10px",
    margin: 0
  },
  radioRoot: {
    padding: "5px 12px",
    color: theme.gridTextColor
  },
  formLabel: {
    fontSize: theme.textFontSize,
    padding: "5px 0px",
    color: theme.gridTextColor
  },
  formControlLabel: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.gridTextColor
  },
  button: {
    textTransform: "none"
  }
});

class RouteConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: "City" };
  }

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          open={true}
          onClose={this.props.close}
          classes={{ paper: classes.dialog }}
          aria-labelledby="RouteConfirmationModal-title"
        >
          <DialogTitle
            id="RouteConfirmationModal-title"
            disableTypography
            classes={{ root: classes.dialogTitle }}
          >
            <div>
              <span>{`Create Route ${this.props.routeName}`}</span>
            </div>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContent }}>
            <div>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  focused={false}
                  classes={{ root: classes.formLabel }}
                >
                  Select the type of route:
                </FormLabel>
                <RadioGroup
                  aria-label="routeType"
                  name="routeType"
                  value={this.state.value}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value="City"
                    control={
                      <Radio
                        color="primary"
                        classes={{ root: classes.radioRoot }}
                      />
                    }
                    label="CITY ROUTE"
                    classes={{ label: classes.formControlLabel }}
                  />
                  <FormControlLabel
                    value="Trap"
                    control={
                      <Radio
                        color="primary"
                        classes={{ root: classes.radioRoot }}
                      />
                    }
                    label="TRAP ROUTE"
                    classes={{ label: classes.formControlLabel }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </DialogContent>
          <DialogActions classes={{ root: classes.dialogAction }}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              classes={{ root: classes.button }}
              onClick={this.props.close}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              classes={{ root: classes.button }}
              onClick={() => this.props.confirm(this.state.value)}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(style)(RouteConfirmationModal);
